import { render } from "./UbicarArticulosPage.vue?vue&type=template&id=688223c1&scoped=true"
import script from "./UbicarArticulosPage.vue?vue&type=script&lang=js"
export * from "./UbicarArticulosPage.vue?vue&type=script&lang=js"

import "./UbicarArticulosPage.vue?vue&type=style&index=0&id=688223c1&scoped=true&lang=scss"

import exportComponent from "C:\\GIT CLONADO\\ubiku.2023\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-688223c1"]])

export default __exports__